

<body class="mat-app-background">
    <div class="container-fluid">
            <div class="col-12 ccorbit-form-group without-icon">
                <div class="row border-bottom" style="height: 100%;">
                    <h5 class="etiquetas">SELECCIONAR CARTERA EXISTENTE</h5>
                    <div class="col-12">
                        <!--                     <mat-checkbox class="gray-color" >Hola</mat-checkbox >
 --> <label class="fw-semibold gray-color ">Abrir Cartera</label>
                    </div>
                    <div class="col-12">
                        <select class="form-select form-select-sm listas" aria-label=".form-select-sm example"
                            style="border: 1px solid gray;" [(ngModel)]="optimaseleccionada">
                            <option [ngValue]="null" selected>Selecciona</option>
                            <option value="{{modelo}}" [ngValue]="modelo" *ngFor="let modelo of listModelo">
                                {{modelo.nombre}}
                            </option>
                        </select>
                        <button mat-flat-button class="ccorbit d-block fw-semibold mt-2" (click)="abrirCartera()">
                            Abrir Cartera
                        </button>
                    </div>
                </div>
        </div>
    </div>
</body>